import dayjs from 'dayjs';
export function generate({ period, periodIn, method, from, }) {
    const dateNow = dayjs(from);
    const methodsAvailable = {
        past: 'subtract',
        future: 'add',
    };
    if (method === 'now')
        return dateNow;
    return dayjs(from)[methodsAvailable[method]](period, periodIn);
}
//# sourceMappingURL=generate.js.map